// @flow

import React from 'react';

const Discover = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="29"
    height="20"
    viewBox="0 0 29 20">
    <g fill="none" fillRule="evenodd">
      <rect width="29" height="20" fill="#FFA200" rx="2.741" />
      <path
        fill="#FFF"
        d="M25.013 9.796h-.22V8.67h.22c.482 0 .701.208.701.542 0 .375-.219.584-.701.584zm1.49-.626c0-.709-.482-1.084-1.359-1.084h-1.096v3.711h.745v-1.5h.088l1.009 1.5h.92l-1.183-1.543c.526-.083.92-.542.877-1.084zm-5.042 2.627h2.105v-.625h-1.36V10.17h1.316v-.626h-1.316v-.833h1.36v-.626H21.46v3.711zm-2.193-1.21L18.26 8.087h-.79l1.623 3.795h.395l1.622-3.795h-.79l-1.052 2.502zm-8.901-.625c0 1.043.877 1.919 1.973 1.919.35 0 .658-.084.965-.209v-.834c-.22.25-.526.417-.877.417-.702 0-1.272-.5-1.272-1.167v-.084c-.044-.667.526-1.25 1.228-1.292.35 0 .701.166.92.416v-.833c-.262-.167-.613-.209-.92-.209-1.14-.083-2.017.792-2.017 1.876zm-1.36-.458c-.438-.167-.57-.25-.57-.459.044-.25.263-.459.527-.417.219 0 .438.125.613.292l.395-.5c-.307-.25-.701-.417-1.096-.417-.614-.042-1.14.417-1.184 1v.042c0 .5.22.792.92 1 .176.043.352.126.527.21.132.083.22.208.22.375 0 .292-.264.542-.527.542h-.044a.868.868 0 0 1-.79-.5l-.481.458c.263.459.789.709 1.315.709.702.042 1.272-.459 1.316-1.126v-.125c-.044-.5-.264-.75-1.14-1.084zm-2.543 2.293h.746V8.086h-.746v3.711zm-1.49-.917a1.438 1.438 0 0 1-1.01.292h-.219v-2.46h.22c.35-.042.745.083 1.008.291.263.25.395.584.395.918 0 .375-.132.709-.395.959zm-.878-2.794H3v3.711h1.096c.483.042.965-.125 1.36-.417.438-.375.701-.875.701-1.418.044-1-.79-1.834-1.842-1.876h-.219zM15.541 8c-1.096 0-2.017.834-2.017 1.918 0 1.043.877 1.918 2.017 1.96 1.14.042 2.017-.834 2.061-1.918A2.038 2.038 0 0 0 15.542 8z"
      />
    </g>
  </svg>
);

export default Discover;



// WEBPACK FOOTER //
// ./src/assets/icons/card-discover-svg.js